import { Box, Typography, Card, CardMedia, CardContent } from "@mui/material";

const LifeAtCompany = () => {
  const images = [
    "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw",
    "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw",
    "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw",
  ];

  const brandBlue = "#1a237e";
  const brandRed = "#d50000";

  return (
    <Box
      sx={{
        py: 10,
        px: { xs: 2, md: 6 },
        background: "linear-gradient(135deg, #f7f9ff, #eef2ff)",
        position: "relative",
      }}
    >
      <Typography
        variant="h4"
        align="center"
        fontWeight={800}
        mb={1}
        sx={{ color: "#1a237e" }}
      >
        Life at Burj Al Yarmouk
      </Typography>

      <Box
        sx={{
          width: 90,
          height: 4,
          background: brandRed,
          mx: "auto",
          borderRadius: 2,
          mb: 5,
        }}
      />

      {/* FLEXBOX WRAPPER */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 3,
        }}
      >
        {images.map((img, idx) => (
          <Card
            key={idx}
            sx={{
              width: {
                xs: "100%", // mobile: 1 card per row
                sm: "48%", // tablet: 2 cards per row
                md: "30%", // desktop: 3 cards per row
              },
              borderRadius: "20px",
              overflow: "hidden",
              background: "#fff",
              boxShadow:
                "0 6px 14px rgba(0,0,0,0.06), 0 3px 6px rgba(0,0,0,0.04)",
              transition: "all .35s ease",
              "&:hover": {
                transform: "translateY(-6px)",
                boxShadow:
                  "0 10px 24px rgba(0,0,0,0.10), 0 4px 10px rgba(0,0,0,0.06)",
              },
            }}
          >
            {/* <CardMedia
              component="img"
              height="170"
              image={img}
              alt="Life at Company"
              sx={{
                objectFit: "cover",
                transition: "all .35s ease",
                "&:hover": { transform: "scale(1.04)" },
              }}
            /> */}

            <CardContent sx={{ textAlign: "center", py: 2 }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "0.95rem",
                  fontWeight: 600,
                  color: "#333",
                }}
              >
                Dedicated. Skilled. United as One Team.
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default LifeAtCompany;
